/**
 * Returns object without properties with empty strings or undefined values [First level only]
 * @param value object to clean
 * @example
 * ```ts
 * cleanEmptyString({name: 'franco', age: 0, surname: ''})
 * // => {name: 'franco', age: 0}
 * ```
 * @param obj object to clean
 * @typeParam T type of object to clean
 * @returns T
 *
 */
export const cleanObjectWithEmptyString = <T extends object>(obj: T) =>
  (Object.keys(obj ?? {}) as (keyof T)[]).reduce(
    (acc, current) =>
      obj[current] || obj[current] !== ''
        ? { ...acc, [current]: obj[current] }
        : acc,
    {} as T
  );
